import React from "react";

import { twMerge } from "tailwind-merge";

type SkeletonProps = {
  className?: string;
  /**
   * When children are provided, they are rendered invisibly to preserve
   * layout dimensions while a pulsing overlay fills the same space.
   * Use `inline` for text/inline content (default), or set it to `false`
   * for block-level children that should fill available width.
   *
   * Without children, renders a standalone animated block whose size
   * is controlled via className.
   */
  children?: React.ReactNode;
  /** Use inline mode for text/spans, block mode for divs/full-width content. */
  inline?: boolean;
};

export function Skeleton({
  className,
  children,
  inline = true,
}: SkeletonProps) {
  if (children) {
    const Tag = inline ? "span" : "div";
    return (
      <Tag className={twMerge("relative", inline ? "inline-flex" : "flex")}>
        <Tag className="invisible" aria-hidden="true">
          {children}
        </Tag>
        <Tag
          className={twMerge(
            "bg-fill-neutral absolute inset-0 animate-pulse rounded",
            className,
          )}
        />
      </Tag>
    );
  }

  return (
    <div
      className={twMerge("bg-fill-neutral animate-pulse rounded", className)}
    />
  );
}
